import React from "react";
import { withTranslation } from "react-i18next";
import StaffAvailabilityWeeklyView from "accountOwner/pages/Scheduler/OfficeSchedulerTab/SubTabs/StaffAvailabilityTab/StaffAvailabilityView/StaffAvailabilityWeeklyView";
import { useAccountOwnerCommon } from "lib/Context/AccountOwner";
import {
  EVENT_WEEKLY_SORT,
  resolveEventWeeklySort,
} from "./eventWeeklyLayout.constants";

/**
 * Weekly event workspace grid: staff rows × day columns (View by Staff Name).
 */
function EventsShiftsWeeklyByStaff({
  t,
  currentDate,
  selectedOfficeFilter,
  selectedEmpFilter,
  searchValue,
  isSidebarActive,
  viewSettingFilter,
  eventShiftFilter,
  isEnterpriseFilterActive,
  appliedPublishedDraftFilter,
  setcurrentDate,
  upDateListonApply,
  bulkSelectMode,
  selectedEvents,
  isBulkActionLoading,
  handleEventSelectionToggle,
  handleSelectableEventsUpdate,
  onVisibleDraftEventsUpdate,
  onVisibleClearableItemsUpdate,
  settotalEvents,
  canAddShift,
  sortStaffBy = EVENT_WEEKLY_SORT.STAFF_NAME_ASC,
}) {
  const { selectedId: selectedOwnerId, profile } = useAccountOwnerCommon();
  const resolvedSortStaffBy = resolveEventWeeklySort(sortStaffBy);

  return (
    <StaffAvailabilityWeeklyView
      t={t}
      currentDate={currentDate}
      selectedOwnerId={selectedOwnerId}
      currentUserId={profile?.id}
      apiOffices={selectedOfficeFilter}
      apiEmps={selectedEmpFilter}
      isSidebarActive={isSidebarActive}
      isWeekly
      agendaTypes={[]}
      cachedEventFilter={[]}
      viewSettingFilter={viewSettingFilter}
      searchValue={searchValue}
      isEnterpriseFilterActive={isEnterpriseFilterActive}
      onDateChange={setcurrentDate}
      canShowOfficeName
      eventsWorkspaceMode
      eventShiftFilter={eventShiftFilter}
      appliedPublishedDraftFilter={appliedPublishedDraftFilter}
      bulkSelectMode={bulkSelectMode}
      selectedEventKeys={selectedEvents}
      onEventSelectionToggle={handleEventSelectionToggle}
      onSelectableEventsUpdate={handleSelectableEventsUpdate}
      onVisibleDraftEventsUpdate={onVisibleDraftEventsUpdate}
      onVisibleClearableItemsUpdate={onVisibleClearableItemsUpdate}
      sortStaffBy={resolvedSortStaffBy}
      isBulkActionLoading={isBulkActionLoading}
      upDateListonApply={upDateListonApply}
      settotalEvents={settotalEvents}
      canAddShift={canAddShift}
    />
  );
}

export default withTranslation()(EventsShiftsWeeklyByStaff);
